module.exports = __webpack_public_path__ + "assets/b23.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b23.png
// module id = 609
// module chunks = 0